import React from 'react';

const Testimonials = () => {
  const testimonials = [
    {
      quote: "Framecast has become essential for our morning research briefings. The FDI scores help us catch narrative divergence before it impacts our positions.",
      author: "Sarah Chen",
      role: "Senior Analyst",
      company: "Global Macro Fund"
    },
    {
      quote: "Finally, a tool that shows us how our company is being framed across different markets. We caught a regional reputation issue weeks before it escalated.",
      author: "Michael Torres",
      role: "VP Communications",
      company: "Fortune 500 Tech"
    },
    {
      quote: "The API is exactly what we needed to integrate narrative intelligence into our research workflow. Setup took minutes, not months.",
      author: "David Park",
      role: "CTO",
      company: "FinTech Startup"
    }
  ];

  return (
    <section className="testimonials-section" data-testid="testimonials">
      <div className="testimonials-inner">
        <div className="section-label">What Teams Say</div>
        <h2>Trusted by researchers, analysts, and communicators</h2>
        
        <div className="testimonials-grid">
          {testimonials.map((t, i) => (
            <div key={i} className="testimonial-card">
              <div className="quote-mark">"</div>
              <p className="testimonial-quote">{t.quote}</p>
              <div className="testimonial-author">
                <div className="author-avatar">{t.author.charAt(0)}</div>
                <div className="author-info">
                  <span className="author-name">{t.author}</span>
                  <span className="author-role">{t.role}, {t.company}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
        
        <div className="trust-logos">
          <span className="trust-label">Built for teams at</span>
          <div className="logos">
            <span className="logo-placeholder">Investment Firms</span>
            <span className="logo-placeholder">PR Agencies</span>
            <span className="logo-placeholder">Think Tanks</span>
            <span className="logo-placeholder">Newsrooms</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
